<div>
  <h4 class="title-center mb-2">Failed Loans</h4>

  @if(haveData === true){
    @if(gettingData === false){
      <div class="title-center mt-5">
        <div class="no-records-message">Loading failed.</div>
      </div>
    } @else {
      <div class="title-center mt-5">
        <app-lt-spinner></app-lt-spinner>
      </div>
    }
  } @else {
    @if(allData){
      <app-lt-generic-grid-wrapper
        [data]="allData"
        [columns]="allColumns"
        [exportFileName]="exportFileName"
        [isResizeable]="true"
        [showExportToolbar]="true"
        [sortDescriptions]="sortDescs"
        [loading]="gettingData"
        >
      </app-lt-generic-grid-wrapper>
    }
  }
</div>
